import { render } from "./Webcam.vue?vue&type=template&id=4f4d4b48&scoped=true"
import script from "./Webcam.vue?vue&type=script&lang=js"
export * from "./Webcam.vue?vue&type=script&lang=js"

import "./Webcam.vue?vue&type=style&index=0&id=4f4d4b48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4d4b48"]])

export default __exports__